<template>
  <v-layout class="py-4">
    <v-flex>
      <img src="@/assets/icons/icn_clock.svg" alt="Image: Clock" class="mb-4 card-scheduled__image" />

      <h4
        class="card-scheduled__title card-scheduled__title--success mb-1"
        v-html="$t(`Common.success`)"
      />
      <h4 class="card-scheduled__title mb-4" v-html="$t(`${namespace}.exportReportSuccessTitle`)" />

      <p class="card-scheduled__text" v-html="$t(`${namespace}.exportReportSuccessText`)" />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ScheduledReport',
  data () {
    return {
      namespace: 'Views.ConsolidatedReportPage'
    }
  }
}
</script>

<style lang="scss" scoped>
.card-scheduled__image {
  display: block;
  margin: auto;
}

.card-scheduled__title {
  max-width: 385px;
  color: #4a4b4a;
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  margin: auto;
  text-align: center;

  &--success {
    color: #62d892;
  }
}

.card-scheduled__text {
  max-width: 550px;
  color: #4a4b4a;
  font-family: 'Work Sans';
  font-size: 14px;
  line-height: 20px;
  margin: auto;
  text-align: center;
}
</style>
